import React, { FC } from 'react'
import isFunction from 'lodash/isFunction'

import { RouteConfigProps } from '../../routes'
import Topbar from '@/checkout-instore-legacy/components/Commons/Topbar'
import { getCurrentRouteByLocation } from '@/checkout-instore-legacy/utils/getCurrentRouteByLocation'

type Location = {
  name: string
  pathname: string
}

type AppTopBarProps = {
  location: Location
  currentPathname: string
  setSidebarVisibility: (isOpen: boolean) => void
}

const shouldHideTopbar = (
  currentRoute: RouteConfigProps,
  location: Location
) => {
  return isFunction(currentRoute.hideTopbar)
    ? currentRoute.hideTopbar(location)
    : currentRoute.hideTopbar ?? false
}

export const AppTopBar: FC<AppTopBarProps> = ({
  location,
  currentPathname,
  setSidebarVisibility,
}) => {
  const currentRoute = getCurrentRouteByLocation(currentPathname)

  if (!currentRoute) {
    return null
  }

  const { titleId, title } = currentRoute
  const customTopbar = currentRoute.customTopbar ?? false
  const hideTopbar = shouldHideTopbar(currentRoute, location)
  const topbarButton = currentRoute.topbarButton ?? 'back'
  const showSearch = currentRoute.showSearch ?? false
  const showBarcode = currentRoute.showBarcode ?? false
  const topbarMode = currentRoute.topbarMode ?? 'normal'

  return !hideTopbar && !customTopbar ? (
    <div id="topbar" className="flex-none z-1 no-print">
      <Topbar
        setSidebarVisibility={setSidebarVisibility}
        leftButton={topbarButton}
        showSearch={showSearch}
        location={location}
        showBarcode={showBarcode}
        titleId={titleId}
        title={title}
        mode={topbarMode}
      />
    </div>
  ) : null
}
